"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _tsRes = require("ts-res");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TargetFeatureFlag = void 0;
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var TargetFeatureFlag = /*#__PURE__*/function () {
  function TargetFeatureFlag(a) {
    _classCallCheck(this, TargetFeatureFlag);
    var b = a.featureFlagId,
      c = a.variationKey,
      d = a.ruleId;
    _defineProperty(this, "featureId", void 0), _defineProperty(this, "ruleId", void 0), _defineProperty(this, "variationKey", void 0), this.featureId = b, this.ruleId = d, this.variationKey = c;
  }
  return _createClass(TargetFeatureFlag, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.variationData,
        c = a.ruleMap;
      if (!this.featureId || !c) return (0, _tsRes.Ok)(!1);
      if (this.featureId && !this.ruleId && !this.variationKey) {
        var _iterator = _createForOfIteratorHelper(c),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref = _step.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var _ = _ref2[0];
            var _a = _ref2[1];
            var d;
            var _c = _a.featureId,
              _e = _a.experimentId;
            if (_c === this.featureId && "number" == typeof (null === (d = b[_e]) || void 0 === d ? void 0 : d.variationId)) return (0, _tsRes.Ok)(!0);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return (0, _tsRes.Ok)(!1);
      }
      if (this.featureId && this.ruleId) {
        var e;
        var _a2 = c.get(this.ruleId);
        if (!_a2) return (0, _tsRes.Ok)(!1);
        var _d = _a2.experimentId,
          _g = _a2.variations;
        if (this.variationKey) {
          var f;
          var _a3 = _g.get(this.variationKey);
          return (0, _tsRes.Ok)(!!_a3 && (null === (f = b[_d]) || void 0 === f ? void 0 : f.variationId) === _a3);
        }
        return (0, _tsRes.Ok)(null !== (e = b[_a2.experimentId]) && void 0 !== e && e.variationId);
      }
      if (this.featureId && !this.ruleId && this.variationKey) {
        var _iterator2 = _createForOfIteratorHelper(c),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _ref3 = _step2.value;
            var _ref4 = _slicedToArray(_ref3, 2);
            var _2 = _ref4[0];
            var _a4 = _ref4[1];
            var _c2 = _a4.featureId,
              _d2 = _a4.experimentId,
              _e2 = _a4.variations;
            if (_c2 === this.featureId && _e2.has(this.variationKey)) {
              var g;
              var _a5 = _e2.get(this.variationKey);
              return (0, _tsRes.Ok)(!!_a5 && (null === (g = b[_d2]) || void 0 === g ? void 0 : g.variationId) === _a5);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return (0, _tsRes.Ok)(!1);
    }
  }]);
}();
exports.TargetFeatureFlag = TargetFeatureFlag;